module.exports = __webpack_public_path__ + "img/ar.4d01e57.svg";